import { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useSessionStorage } from 'usehooks-ts';
import Mine from '../Components/Mine';

interface GameSettings {
    cols: number,
    rows: number,
    mines: number
}

enum SquareState {
    Hidden,
    Revealed,
    Flagged,
}

interface Square {
    isMine: boolean,
    squareState: SquareState
}



export default function Minesweeper() {
    const [gameSettings, setGameSettings] = useSessionStorage<GameSettings>("gameSettings", {cols: 9, rows: 9, mines: 10});
    const [mineState, setMineState] = useState<SquareState[][]>(initializeMines(gameSettings));
    //function onActivate (x : number, y : number) {
    //    const mine = mineState[x][y];
    //    if (mineState[x][y].mine) {
    //        newState[x][y].display = "X";
            
    //        setGameOver(true);
    //    } else {
    //        const maxX = x === size.cols - 1;
    //        const minX = x === 0;

    //        const maxY = y === size.rows - 1;
    //        const minY = y === 0;

    //        const adjacentSquares = [];

    //        if (!maxX) {
    //            adjacentSquares.push(newState[x + 1][y])
    //        }
    //        if (!minX) {
    //            adjacentSquares.push(newState[x - 1][y])
    //        }
    //        if (!maxY) {
    //            adjacentSquares.push(newState[x][y + 1])
    //        }
    //        if (!minY) {
    //            adjacentSquares.push(newState[x][y - 1])
    //        }

    //        if (!maxX && !maxY) {
    //            adjacentSquares.push(newState[x + 1][y + 1])
    //        }

    //        if (!maxX && !minY) {
    //            adjacentSquares.push(newState[x + 1][y - 1])
    //        }

    //        if (!minX && !minY) {
    //            adjacentSquares.push(newState[x - 1][y - 1])
    //        }

    //        if (!minX && !maxY) {
    //            adjacentSquares.push(newState[x - 1][y + 1])
    //        }


    //        let mineCount = 0;

    //        adjacentSquares.forEach((sq) => {
    //            if (sq.mine) {
    //                mineCount++;
    //            }
    //        });

    //        newState[x][y].display = mineCount;

    //        if (mineCount === 0) {
    //            adjacentSquares.forEach((sq) => {
    //                if (sq.display === "_") {
    //                    onActivate(sq.x, sq.y, newState);
    //                }
    //            });
    //        }
            
    //    }
    //    setMineState(newState);
        
    //}
    
    return (
        <div>
            <Stack direction="row">
                {mineState.map((row) => <Stack>
                    {row.map((m) => <Mine />)}
                </Stack>)}
            </Stack>
        </div>
    );
}

function initializeMines(settings : GameSettings) {
    const board = new Array(settings.cols);
    for (var x = 0; x < settings.cols; x++) {
        board[x] = new Array(settings.rows);
        for (var y = 0; y < settings.rows; y++) {

            board[x][y] = { mine: false, x: x, y: y, display: "_" }
        }
    }
    const squareCount = settings.cols * settings.rows;
    const unusedIndexes = [...Array(squareCount).keys()]
    for (var m = 0; m < settings.mines; m++) {
        const unusedIndexIndex = Math.floor(Math.random() * unusedIndexes.length);
        const unusedIndex = unusedIndexes[unusedIndexIndex];

        const x = Math.floor(unusedIndex / settings.rows);
        const y = unusedIndex % settings.rows;
        board[x][y].mine = true;

        unusedIndexes.splice(unusedIndexIndex, 1);
    }
    return board;
}
